// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2hyAI","unreadBadge":"styles_unreadBadge__CXySo","modalContent":"styles_modalContent__3Okh8","modal":"styles_modal__3QPzV"};